import "./BaseModalContent.scss";
import clsx from "clsx";

type BaseModalContentProps = {
  className?: string;
  classNameModalContent?: string;
  children: React.ReactNode;
};

export const BaseModalContent = ({
  className,
  children,
  classNameModalContent = "ui-base-modal-content",
}: BaseModalContentProps) => {
  return (
    <div
      className={clsx(classNameModalContent, `${className ? className : ""}`)}
    >
      {children}
    </div>
  );
};
